import { Component, Inject, OnInit } from "@angular/core";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { GlobalVariable } from "../../app.component";
import { DataService, Response } from "../../dataService/data.service";


@Component({
  selector: "app-google-analytics",
  templateUrl: "./google-analytics.component.html",
  styleUrls: ["./google-analytics.component.scss"],
})
export class GoogleAnalyticsComponent implements OnInit {
  public loading = false;
  private BASE_URL = GlobalVariable;
  outletId: string;
  insightsDataViews: any;
  insightsDataAction: any;
  insightsDataSearch: any;
  facebookCheck: string;
  googleCheck: string;
  verify_check: any;
  gmbIndividualComponents: any;

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private httpService: DataService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.outletId = this.storage.get("outlet_id");
    this.insights();
    this.verifyCheck();
  }

  insights() {
    let res: Response;
    const optinService = this.httpService.get(
      this.BASE_URL.INSIGHTS(this.outletId)
    );
    optinService.subscribe((res: Response) => {
      if (res.code == 200) {
        this.insightsDataSearch = res.data[0]["total_searches"];
        this.insightsDataViews = res.data[1]["total_views"];
        this.insightsDataAction = res.data[2]["total_actions"];
      }
    });
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  verifyCheck() {
    // let res: Response;
    // const optinService = this.httpService.get(this.BASE_URL.SOCIAL_AUTH_VERIFY_URL(this.outletId));
    // optinService.subscribe((data: Response) => {
    //   res = data;
    //   this.facebookCheck = res.data['facebook'];
    //   this.googleCheck = res.data['google'];
    // });
    // setTimeout(() => {
    //   this.loading = false;
    // }, 1000);

    // used localstorege to fix verify api multiple call issue in dashboard

    this.verify_check = this.storage.get("isIntegrated");
    this.facebookCheck = this.verify_check["facebook"];
    this.googleCheck = this.verify_check["google"];
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    // console.log('verify_check',this.verify_check);
  }
}
